<div class="toast-container">
  @for (toast of toasts$ | async; track toast.id) {
    <div
      class="toast"
      [class]="'toast toast-' + toast.type"
      [class.toast-leaving]="toast.leaving"
      [attr.role]="toast.type === ToastType.Error ? 'alert' : 'status'"
      [attr.aria-live]="toast.type === ToastType.Error ? 'assertive' : 'polite'"
      (mouseenter)="pause(toast.id)"
      (mouseleave)="resume(toast.id)"
      (focusin)="pause(toast.id)"
      (focusout)="resume(toast.id)"
    >
      <div class="toast-icon" aria-hidden="true">
        @switch (toast.type) {
          @case (ToastType.Success) {
            <svg lucideCircleCheck></svg>
          }
          @case (ToastType.Error) {
            <svg lucideCircleX></svg>
          }
          @case (ToastType.Warning) {
            <svg lucideAlertCircle></svg>
          }
          @default {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="16" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
          }
        }
      </div>
      <div class="toast-body">
        <div class="toast-title">{{ titleOf(toast) }}</div>
        <div class="toast-message">{{ toast.message }}</div>
      </div>
      <button type="button" class="toast-close" (click)="dismiss(toast.id)" aria-label="Dismiss notification">
        <svg lucideX></svg>
      </button>
      <span class="toast-progress" [style.animation-duration.ms]="toast.duration" aria-hidden="true"></span>
    </div>
  }
</div>
